// export const sessionStorageTokenVariable = 'currentUserToken';
// export const sessionStorageTwoFactorTokenVariable = 'twoFactorToken';
export const localStorageTwoFactorUUIDVariable = 'deviceid';
export const DEMOUSEREMAIL = 'demo.*@ingeteam.com';
